import type { CSSProperties } from "react"

import { tv, type VariantProps } from "@/lib/utils/tv"

const skeleton = tv({
  base: "bg-surface-muted motion-safe:animate-pulse",
  variants: {
    shape: { line: "rounded-4x", circle: "rounded-full", card: "rounded-8x" },
  },
  defaultVariants: { shape: "line" },
})

interface SkeletonProps extends VariantProps<typeof skeleton> {
  className?: string
  style?: CSSProperties
}

export const Skeleton = ({ shape, className, style }: SkeletonProps) => <div aria-hidden className={skeleton({ shape, className })} style={style} />
